/* DOM: accessible tabs (scoped per tab group) */
(function () {
  function init(root) {
    root.querySelectorAll('[role="tablist"]').forEach(function (list) {
      if (list.dataset.dReady) return;
      list.dataset.dReady = '1';
      var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
      function select(t, focus) {
        tabs.forEach(function (x) {
          var on = x === t;
          x.setAttribute('aria-selected', on);
          x.tabIndex = on ? 0 : -1;
          var p = document.getElementById(x.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
        if (focus) t.focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); select(tabs[(i + 1) % tabs.length], true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); select(tabs[(i - 1 + tabs.length) % tabs.length], true); }
        });
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var p = e.target.closest('[role="tabpanel"]');
    if (p) { var t = document.getElementById(p.getAttribute('aria-labelledby')); if (t) t.click(); }
  });
})();
